import { ensureOrgContext } from "@/lib/utils/org-context-guard";
import { isOnboardingCompleted } from "@/lib/utils/organization";
import type { OrgRouteContext } from "./route";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(org)/o/$orgSlug/dashboard")({
  beforeLoad: ({ context, params }) => {
    const { organization } = context as OrgRouteContext;
    if (
      !ensureOrgContext(
        organization,
        "(org)/o.$orgSlug/dashboard.tsx#beforeLoad",
        { orgSlug: params.orgSlug },
      )
    ) {
      throw redirect({ to: "/", search: { error: "organization_not_found" } });
    }
    if (!isOnboardingCompleted(organization.metadata)) {
      throw redirect({
        to: "/o/$orgSlug/onboarding",
        params: { orgSlug: params.orgSlug },
      });
    }
  },
});
